import { writable } from 'svelte/store';
import { initTableStore, connectSearchParamsToTableStore } from "../../../stores/TableStore.js";

export function initOperationTableStore() {
  const EnableResultEdit = writable(false)
  const UsingCompactStyle = writable(false)  // whether the "compact" style (all columns in one page) should be used

  return {
    ...initTableStore(),
    EnableResultEdit,
    UsingCompactStyle,
  }
}

export function connectSearchParamsToOperationTableStore(OperationTableStore, searchParams = new URLSearchParams(window.location.search)) {
  return connectSearchParamsToTableStore(OperationTableStore, searchParams)
}
